/*----------------------------------------------------

	carousel.js

----------------------------------------------------*/

var interval = ($('.carousel').data('interval')) ? $('.carousel').data('interval') : 5000;
var speed = 500;
var container = $('.carousel__viewport');
var play_loop;

var carousel_width;

// -----------------------------------------------------------------------------------
// A. navigation
// -----------------------------------------------------------------------------------

function carouselInit(){

  carousel_width = $('.carousel').width();

  // navigation
  var hash = window.location.hash.substr(1);
  if(hash){
    $('.carousel__navigation a[href="#' + hash + '"]').addClass('current');
  }else{
    $('.carousel__navigation a').first().addClass('current');
  }
  bindNavigation();

  // autoplay
  autoPlay();

}
carouselInit();



// -----------------------------------------------------------------------------------
// B. navigation
// -----------------------------------------------------------------------------------

function bindNavigation(){

  $('.carousel__navigation a').click(function(ev){

    ev.preventDefault();

    if($(this).hasClass('current')){
      // do nothing

    }else{

      var target = $(this).attr('href');
      animateCarousel(target)
      updateCurrentPage(this);

      clearInterval(play_loop);

    }

  });

}


function updateCurrentPage(obj){

  $(obj).closest('.carousel__navigation').find('.current').removeClass('current');
  $(obj).addClass('current');

}

function animateCarousel(target){

  var target_num = parseInt($(target).attr('data-num'));

  var shift = Math.round(carousel_width * (target_num - 1));

  $(container).stop().animate({
    scrollLeft: shift
  }, speed);

}


// -----------------------------------------------------------------------------------
// C. autoplay
// -----------------------------------------------------------------------------------

function autoPlay(){

  play_loop = setInterval(function(){

    var curr_parent = $('.carousel__navigation a.current').parent();
    var next = $(curr_parent).next().find('a');
    var next = (next.length > 0) ? next : $('.carousel__navigation a').first();

    var target = next.attr('href');
    animateCarousel(target);
    updateCurrentPage(next);

  }, interval);

}



// -----------------------------------------------------------------------------------
// D. resize
// -----------------------------------------------------------------------------------

$(window).smartresize(function(){
  $(container).stop().animate({
    scrollLeft: 0
  }, 0);
  updateCurrentPage($('.carousel__navigation a').first());
  carousel_width = $('.carousel').width();
});